import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdsForSettingsService } from '../../ids-for-settings.service';

@Component({
  templateUrl: './organisation-user.layout.html'
})
export class OrganisationUserLayout implements OnDestroy {

  userName: string = "";
  userNameSubscription: Subscription;
  constructor(private idsForSettingsService: IdsForSettingsService) {
    this.userNameSubscription = this.idsForSettingsService.selectedUserName$.subscribe(userName => {
      this.userName = userName;
    });

  }
  ngOnDestroy(): void {
    // first unsubscribe since we do not care anymore
    this.userNameSubscription.unsubscribe();
  }
}
